import { faPlus } from "@fortawesome/free-solid-svg-icons";
import type { File } from "app/util/workspace";
import styles from "./tabs.style.module.scss";
import EXAMPLE_TEMPLATES from "./examples";
export interface Input {
  files: File[];
  filesChange: (files: File[]) => void;
  selected: number;
  selectedChange?: (newSelected: number) => void;
}

let/tabs:=input.files
let/selected:=input.selected
let/editingIndex=-1

div class=styles.tabs
  div class=styles.files
    for|tab, i| of=tabs
      const/isSelected=selected === i
      const/isEditable=i !== 0
      const/isEditing=editingIndex === i

      div
        ,aria-selected=isSelected && "true"
        ,tabindex=0
        ,role="button"
        ,onClick() {
          if (isSelected && !isEditing) {
            editingIndex = i;
          } else if (!isEditing) {
            selected = i;
          }
        }
        ,onKeyDown(e, el) {
          if (e.target === el && (e.key === " " || e.key === "Enter")) {
            if (isSelected && !isEditing) {
              editingIndex = i;
            } else if (!isEditing) {
              selected = i;
            }
          }
        }
        ,class=styles.tab
        if=isEditing
          let/length=(tab.path.length)
          input/$input
            ,value=tab.path
            ,size=length
            ,onInput(_, el) {
              length = el.value.length;
            }
            ,onBlur(_, el) {
              tabs = tabs.toSpliced(i, 1, { ...tab, path: el.value });
              editingIndex = -1;
            }
            ,onKeyDown(e, el) {
              if (e.key === "Enter") {
                document.querySelector<HTMLElement>(".cm-content")?.focus();
              } else if (e.key === "Escape") {
                // Restore the original name and blur so the blur handler
                // saves an unchanged path -- a cancel that doesn't depend
                // on reactive update timing during the unmount.
                el.value = tab.path;
                el.blur();
              }
            }
          script --
            $input().focus();
            $input().setSelectionRange(0, $input().value.lastIndexOf("."));
        else -- ${tab.path}

        if=isEditable
          button
            ,title="Delete file"
            ,onMouseDown(e) {
              // prevent button from stealing focus, so it doesn't move out underneath the mouse
              e.preventDefault();
            }
            ,onClick(e) {
              e.stopPropagation();
              if (selected >= i) {
                selected--;
              }
              tabs = tabs.toSpliced(i, 1);
            }
            ,class=styles.close -- ×

  id/popoverId

  button
    ,title="Add file"
    ,popovertarget=popoverId
    ,class=styles.add
    ,onClick(_, btn) {
      const { top, right } = btn.getBoundingClientRect();
      $popover().style.top = `${top}px`;
      $popover().style.right = `${innerWidth - right}px`;
    }
    fa-icon=faPlus

  div/$popover
    ,id=popoverId
    ,class=styles.popover
    ,popover
    ,role="menu"
    ,onFocusOut(e) {
      if (!$popover().contains(e.relatedTarget as Node)) {
        $popover().hidePopover();
      }
    }
    button
      ,role="menuitem"
      ,autofocus
      ,onClick() {
        const newIndex = tabs.length;
        let path = "Tag.marko";
        for (let i = 1; tabs.some((tab) => tab.path === path); i++) {
          path = "Tag" + i + ".marko";
        }
        tabs = [
          ...tabs,
          {
            path,
            content: "",
          },
        ];
        selected = newIndex;
        editingIndex = newIndex;
      }
      ,class=styles.templateButton -- New Blank File

    for|{ name, content }| of=EXAMPLE_TEMPLATES
      button
        ,role="menuitem"
        ,onClick() {
          selected = tabs.length;
          let path = name + ".marko";
          for (let i = 1; tabs.some((tab) => tab.path === path); i++) {
            path = name + "-" + i + ".marko";
          }
          tabs = [...tabs, { path, content }];
          document.querySelector<HTMLElement>(".cm-content")?.focus();
        }
        ,class=styles.templateButton -- ${`<${name}>`}
